import { render, staticRenderFns } from "./active.vue?vue&type=template&id=96153800&scoped=true&"
import script from "./active.vue?vue&type=script&lang=js&"
export * from "./active.vue?vue&type=script&lang=js&"
import style0 from "./active.vue?vue&type=style&index=0&id=96153800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96153800",
  null
  
)

export default component.exports